<script>
import VuetifyColourClass from '@/shared/constants/core/VuetifyColourClass'

export default {
  name: 'BaseRadioButton',
  model: {
    prop: 'modelValue',
    event: 'input',
  },
  props: {
    modelValue: [String, Number, Boolean],
    value: [String, Number, Boolean],
    name: String,
    size: {
      type: String,
      default: 'md', // options: 'sm', 'md', 'lg'
      validator: (val) => ['sm', 'md', 'lg'].includes(val),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    labelColor: {
      type: String,
      default: 'grey',
    },
  },
  computed: {
    internalValue() {
      return this.value
    },
    sizeClass() {
      return `custom-radio--${this.size}`
    },
    labelColorClass() {
      const resolved = this.getMappedValue(
        VuetifyColourClass.text,
        this.labelColor?.length,
        VuetifyColourClass.text?.[this.labelColor] || 'grey--text'
      )
      return resolved
    },
  },
  methods: {
    getMappedValue(map, condition, fallback) {
      if (!condition) return fallback
      return map?.[this.labelColor] || fallback
    },
  },
}
</script>

<template>
  <label
    class="custom-radio"
    :class="[sizeClass, labelColorClass, { disabled }]"
  >
    <input
      type="radio"
      :name="name"
      :value="value"
      :checked="modelValue === value"
      :disabled="disabled"
      @change="$emit('input', value)"
    />
    <span class="dot"></span>
    <slot></slot>
  </label>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/custom-radio-button.scss';
</style>
